import { useState } from 'react'

import { softwareTilesValues } from '../const'
import {
  StyledSoftwareUpdatesHeader,
  StyledSoftwareUpdatesInfo,
} from '../HomeSoftwareUpdates/styles'
import { HomeSoftwareTitle } from '../styles'
import { RadioTiles } from 'components/RadioTiles'
import { HomeSoftwareUpdateProgressContainer } from './styles'
import HomeCloudSoftwareHistory from '../HomeCloudSoftwareHistory'
import HomeSoftwareHistory from '../HomeSoftwareHistory'

const softwareProgressTiles = [
  {
    label: 'All Updates',
    value: softwareTilesValues.allUpdates,
    defaultChecked: true,
  },
  {
    label: 'Installed',
    value: softwareTilesValues.installedOnly,
  },
]

function HomeSoftwareUpdateProgress() {
  const [showAllUpdates, setShowAllUpdates] = useState(
    softwareTilesValues.allUpdates
  )

  return (
    <HomeSoftwareUpdateProgressContainer>
      <StyledSoftwareUpdatesHeader>
        <StyledSoftwareUpdatesInfo>
          <HomeSoftwareTitle>Update History</HomeSoftwareTitle>
          <RadioTiles
            options={softwareProgressTiles}
            name="filter"
            onChange={setShowAllUpdates}
          />
        </StyledSoftwareUpdatesInfo>
      </StyledSoftwareUpdatesHeader>

      {showAllUpdates === softwareTilesValues.allUpdates && (
        <HomeCloudSoftwareHistory />
      )}

      {showAllUpdates === softwareTilesValues.installedOnly && (
        <HomeSoftwareHistory />
      )}
    </HomeSoftwareUpdateProgressContainer>
  )
}

export default HomeSoftwareUpdateProgress
